import { CreateGroupRequest, CreateGroupResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const createGroup = makeCloudFunction<
  CreateGroupRequest,
  CreateGroupResponse
>("group", "createGroup");
